import { cva } from 'class-variance-authority'
import classNames from 'classnames'
import { InputHTMLAttributes, forwardRef } from 'react'

interface PropTypes extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  placeholder?: string
  error?: string
  containerClassName?: string
}

const inputStyles = cva(
  [
    'w-full bg-transparent text-center text-white peer font-medium text-[14px] leading-6 font-medium placeholder-gray-600 outline-none transition-all appearance-none',
    '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
  ],
  {
    variants: {
      error: {
        true: 'text-error-800',
        false: 'text-gray-700',
      },
    },
  },
)

export default forwardRef<HTMLInputElement, PropTypes>(function MinimalTextInput ({
  name,
  error,
  placeholder,
  ...rest
}, ref) {

  return (
    <>
      <div className="h-11 flex justify-center">
        <input
          data-1p-ignore
          ref={ref}
          name={name}
          placeholder={placeholder}
          {...rest}
          className={classNames(inputStyles({ error: Boolean(error) }))}
        />
      </div>
    </>
  )
})
